import loanFormModel from '../../form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import * as Yup from 'yup';
import { PropertyOwnerPercentOwnedRuleset } from '../../business/ruleset/solar_property';
import { RulesetResult } from '../../business/rules';
import { RELATED_PARTY_RELATIONSHIP } from '../../../../../../../constants';

const { systemPropertyOwnerPercentOwned } = loanFormModel.formField;

export class PropertyOwnerPercentOwnedValidation implements ValidationSchema {
  public name: string = systemPropertyOwnerPercentOwned.name;
  public label = '';
  public type = 'number';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(schema: Yup.StringSchema, context: any) {
    if (!context.from) return schema;
    const application = context.from[1].value;
    const parent = context.parent;
    const index = application.principals.findIndex(
      (principal) =>
        principal.relationship == RELATED_PARTY_RELATIONSHIP.LANDLORD &&
        parent.id == principal.id
    );
    const result =
      PropertyOwnerPercentOwnedRuleset.setIndex(index).evaluate(application);
    if (result & RulesetResult.REQUIRED)
      return schema.max(100).required('This field is required');
    return schema;
  }
}
export default new Validation(new PropertyOwnerPercentOwnedValidation());
